import { G as k, P as C } from "./ProfileTile-cRR6HDCq.js";
import { A as S, C as w, I as W, T as g, W as A } from "./TileSkeleton-GTAZ6jJH.js";
import { j as o, B as I } from "./Spinner-dTAYYnIx.js";
import { styled as r } from "styled-components";
import { I as _ } from "./Image-8P7BYQsX.js";
import { j as d, d as B, T as p } from "./style-8UHgYe1v.js";
import { f as x, e as c, a as E } from "./index-QRkynDgW.js";
import { T as f } from "./typography.styled-aDVGHct9.js";
import { A as G } from "./aspect-ratios-JlfRqse9.js";
const m = r.div`
  width: 100%;
  ${d("margin")};
`, $ = r(_)`
  ${d("transform, opacity")}
`, L = r.div.attrs({
  $flexDirection: "column"
})`
  ${x};

  position: relative;
  height: 100%;

  &:hover {
    ${$} {
      transform: scale(0.95);
    }

    ${m} {
      margin-top: -${c.spacer2};
      margin-bottom: ${c.spacer2};
    }
  }

  * {
    box-sizing: border-box;
  }
`, P = r.div.attrs({
  $flexDirection: "column",
  $justifyContent: "space-between",
  $flexGrow: "1"
})`
  ${E};
  ${x};
`, h = r.a`
  cursor: pointer;

  &::after {
    position: absolute;
    inset: 0 0 34px;
    content: '';
  }

  /* Show "outline" when focused by keyboard only */
  &:focus {
    outline: none !important;
  }

  [data-whatintent='keyboard'] &:focus-within {
    &::after {
      inset: -5px;
      outline: 1px solid;
      ${B("outline-color", "dominant")};
    }
  }
`, R = r(f)`
  ${h} {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
`, z = ({
  image: e,
  primaryTitle: n,
  secondaryTitle: u,
  headingLevel: b = "h3",
  href: s,
  cta: t,
  handleChange: i,
  tabIndex: a
}) => {
  const j = e == null ? void 0 : e.src, y = (e == null ? void 0 : e.alt) ?? "", v = {
    xs: {
      src: j,
      maxWidth: 575,
      aspectRatio: G["7:8"]
    }
  }, l = (T) => i && i(T);
  return /* @__PURE__ */ o.jsxs(L, { "data-qa": "lot-tile", children: [
    /* @__PURE__ */ o.jsx($, { images: v, alt: y, objectFit: "contain" }),
    /* @__PURE__ */ o.jsxs(P, { children: [
      /* @__PURE__ */ o.jsxs(m, { children: [
        /* @__PURE__ */ o.jsx(
          R,
          {
            as: b,
            $pt: "spacer4",
            $variant: p.headingSSerif,
            $textAlign: "left",
            $textEllipsis: 2,
            children: s ? /* @__PURE__ */ o.jsx(h, { tabIndex: a, onClick: l, href: s, children: n }) : n
          }
        ),
        /* @__PURE__ */ o.jsx(f, { as: "p", $textEllipsis: 2, $variant: p.body, $pt: "spacer1", children: u })
      ] }),
      (t == null ? void 0 : t.href) && (t == null ? void 0 : t.text) && /* @__PURE__ */ o.jsx(
        I,
        {
          tabIndex: a,
          variant: "secondary",
          onClick: l,
          fullWidth: !0,
          $mt: "spacer4",
          href: t.href,
          "aria-label": `${t.text} - ${n}`,
          children: t.text
        }
      )
    ] })
  ] });
}, Q = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AnimationBody: S,
  ContentSkeleton: w,
  GenericTile: k,
  ImageSkeleton: W,
  LotTile: z,
  ProfileTile: C,
  TileSkeleton: g,
  Wrapper: A
}, Symbol.toStringTag, { value: "Module" }));
export {
  z as L,
  Q as i
};
